// Shared local-calendar-day key used to group/match fixtures by date across the fixtures
// calendar and the "fixtures on this date" page — always local time, never UTC, so a fixture
// scheduled for 9pm doesn't get attributed to the following day for users west of UTC.
export function toDateParam(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function isSameLocalDate(isoString: string, dateParam: string): boolean {
  return toDateParam(new Date(isoString)) === dateParam;
}
